import { StsBackendOperation } from '../../../sts-backend-operation';

/** Parameters for hiding assets from TechShare display. */
export type HideFromTechShareParams = {
    /** The IDs of the assets to hide from TechShare. */
    assetIds: string[];
};

/**
 * Hide assets from TechShare by setting displayInTechShare to false.
 * This prevents the assets from being visible in TechShare while keeping
 * them available in the Techline case.
 */
export class HideFromTechShare extends StsBackendOperation {
    /**
     * Update the given assets to hide them from TechShare display.
     *
     * @param params - the asset IDs to hide
     */
    async exec(params: HideFromTechShareParams): Promise<void> {
        const { assetIds } = params;

        if (assetIds.length === 0) {
            return;
        }

        await this.client.updateAssets({
            assetsBody: {
                assets: assetIds.map((assetId) => ({
                    assetId,
                    displayInTechShare: false,
                })),
            },
        });
    }
}
